module.exports = __webpack_public_path__ + "images/home-bench-infront-screen-cast.jpg";